export class ReferralKeys {
  referralToken?: string;
}

export class ReferralKeysName {
  referralToken = 'referral_token';
}
